<template lang="pug">
.span
  form.form-inline
    .form-group
      vuejs-datepicker(
        :format="DatePickerFormat"
        :language="language"
        :value="$store.state[this.state_name].date_from"
        @selected="selectMonth"
        input-class="form-control date-picker-width"
        :minimum-view="'month'"
        :maximum-view="'month'"
      )
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'

import vuejsDatepicker from 'vuejs-datepicker'

//components
import ReportCol from '../components/reports/cols.vue'

//mixins
import DateformatMixin from '../mixins/date_format.js'

export default {
  props: {
    date_from: String,
    date_to: String,
    date_yesterday_start: String,
    date_yesterday_end: String,
    date_month_start: String,
    date_last_month_start: String,
    date_last_month_end: String,
    report_type: {type: String, default: "widget"},
    params_date_from:String,
    params_date_to:String,
    state_name: {
      type: String,
      default: "heatmap"
    },
  },
  data(){
    return {
      DatePickerFormat: 'yyyy-MM',
      language:{
        language: 'Japanese',
        months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        monthsAbbr: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        days: ['日', '月', '火', '水', '木', '金', '土'],
        rtl: false,
        ymd: 'yyyy-MM-dd',
        yearSuffix: '年'
      }
    }
  },
  mixins: [DateformatMixin],
  methods: {
    selectMonth(date){
      const month_str = this.formatDateToBegining(date)
      const params = new URLSearchParams(window.location.search)
      params.set('month', month_str)
      params.delete('date_from')
      params.delete('date_to')
      const query = params.toString()
      window.location.href = query ? `${location.pathname}?${query}` : location.pathname

      const date_from = this.formatDateToBegining(date)
      const date_to = this.formatDateToEnd(date)
      this.$store.commit(`${this.state_name}/setDateFrom`, date_from)
      this.$store.commit(`${this.state_name}/setDateTo`, date_to)
    }
  },
  async mounted(){
    await Vue.nextTick()
    if(this.params_date_from){
      this.$store.commit(`${this.state_name}/setDateFrom`, this.params_date_from)
    }else{
      this.$store.commit(`${this.state_name}/setDateFrom`, this.date_from)
    }
    if(this.params_date_to){
      this.$store.commit(`${this.state_name}/setDateTo`, this.params_date_to)
    }else{
      this.$store.commit(`${this.state_name}/setDateTo`, this.date_to)
    }
  },
  watch: {
    
    // '$store.state[this.state_name].date_from': function (val) {
    //   this.getReport()
    // },
    // '$store.state[this.state_name].date_to': function (val) {
    //   this.getReport()
    // },
  },
  computed: {
    is_loading(){
      return this.$store.state[this.state_name].is_loading
    }
  },
  components: {
    vuejsDatepicker,
    ReportCol
  }
}
</script>

<style scoped>
::v-deep .date-picker-width {
  max-width: 120px;
}
</style>
